import {
  SimpleType, UpdTable, BannerFilter, Banner,
} from '@/types';

export default class GlobalState {
  cities: SimpleType[] = [];
  regions: SimpleType[] = [];
  is_mini_sidebar = true;
  is_notification_bar = false;
  is_polls_sidebar = false
  sidebar_width = '300px';
  sidebar_mini_width = '80px';
  time = 0;
  option: string | null = null
  banners: Banner[] = []

  is_clear_locale_storage = false

  table_key = 0

  isMobile = false;
  isTablet = false;
  isLaptop = false;
  isDesktop = false;

  user_guide_path = '';
  contact_information_path = '';

  info_dialog_modal = false;

  filters: BannerFilter = {
    filters: {
      page: null,
    },
  };

  favorits_toggle = false;
  question_toggle = false;

  default_const_max_cart_product_quantity = 10000;

  dadata_error_message = '';
  dadata_error_modal = false;
}
